import BaseComponent from '@/components/base';
import ProductsCancelledDetailsStyle from '@/components/products-cancelled-details/style';
import ProductsColorsStyle from '@/components/products-cancelled-details/productsColorsStyle';
import RechargeGateway from '@/gateway/Recharge';
import ShopifyAPI from '@/gateway/ShopifyAPI';
import { getRequest } from '@/service/requests';

export default class ProductsCancelledDetails extends BaseComponent {
  render() {
    return '<img src="https://cdn.shopify.com/s/files/1/0688/9960/2752/files/loader.gif?v=1713963298">';
  }

  async connectedCallback() {
    this.subscriptions = [];
    await this.getSubscriptionsAndImages();
    if (this.subscriptions.length >= 1) {
      const subscriptionCards = this.subscriptions
        .filter((x) => x.sku)
        .map((sub) => {
          const color = this.productColor(sub.sku);
          return `
          ${ProductsCancelledDetailsStyle()}
          ${ProductsColorsStyle()}
          <div class="card-container">
          <img class="product-image" src="${sub.image}">
            <div class="title-container">
                <p>${sub.product_title}</p>
                <p>${sub.variant_title}</p>
                <div class="color ${color ? color : 'default'}"></div>
            </div>
          </div>`;
        })
        .join('');
      const productsContainer = document.querySelector('.products-container');
      productsContainer.innerHTML = subscriptionCards;
    } else {
      const productsContainer = document.querySelector('.products-container');
      productsContainer.innerHTML = '<h1>No Products Found</h1>';
    }
  }

  async getSubscriptionsAndImages() {
    const urlParams = new URLSearchParams(window.location.search);
    const subscriptions = urlParams.get('subscriptions');
    const subscriptionsArray = JSON.parse(subscriptions);
    const allSubscriptionsObjects =
      await RechargeGateway.getSubscriptionsArray(subscriptionsArray);
    for (const sub of allSubscriptionsObjects) {
      const productHandle = sub.properties.find(
        (prop) => prop.name === '__product_handle'
      );
      const product = await this.getProductByhandle(productHandle.value);
      sub.image = product.media[0].src;
      this.subscriptions.push(sub);
    }
  }

  async getProductByhandle(handle) {
    const response = await ShopifyAPI.getItemByHandle(handle);
    return response;
  }

  productColor(sku) {
    function getColor(string) {
      const match = string.match(/[^.]+$/);
      return match[0];
    }
    const color = getColor(sku);
    return color;
  }
}
